import { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { RemoveDialog } from 'src/containers/Escrow/Remove';
import { useSaasEscrow } from 'src/context/saas-escrow';
import { SaasEscrowsDocument } from 'src/graphql/actions/saasEscrow/saasEscrows.query';
import { apolloClient as client } from 'src/graphql';

const refetchEscrows = () => {
  client.cache.evict({ fieldName: 'saasEscrows' });
  client.cache.gc();
  client.refetchQueries({
    include: [SaasEscrowsDocument],
  });
};

const RemoveAction = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const {
    saasEscrow: { id },
  } = useSaasEscrow();

  const onClose = () => setIsOpen(false);

  const onOpen = () => setIsOpen(true);

  const onSuccess = () => {
    refetchEscrows();
    navigate('/saas-escrows');
  };

  return (
    <RemoveDialog
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      successCallback={onSuccess}
      escrowId={id}
      triggerNode={
        <Button variant="destructive">
          <Trash2 /> Delete escrow
        </Button>
      }
    />
  );
};

export default RemoveAction;
